import React from 'react';
import { useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { darkTheme, lightTheme } from './srsThemes';
import { VaccinationStatus } from './components/VaccinationStatus/VaccinationStatus';
import { SnackbarProvider } from 'notistack';
const themeLight = createTheme(lightTheme);
const themeDark = createTheme(darkTheme);

const App = () => {
	const [darkMode] = React.useState(window.matchMedia('(prefers-color-scheme:dark)').matches);

	useEffect(() => {
		const clearLoader = () => {
			const ele = document.getElementById('progressloader-progress-indicator');
			if (ele) {
				ele.classList.add('available');
				setTimeout(() => {
					ele.outerHTML = '';
				}, 500);
			} else {
				console.log('Could not find \'#progressloader-progress-indicator\' in DOM. Implement this as a loader to have smooth loading.');
			}
		};
		clearLoader();
	}, []);



	return (
		<MuiThemeProvider theme={darkMode ? themeDark : themeLight}>
			<SnackbarProvider maxSnack={3}>
				<CssBaseline />
				<VaccinationStatus />
			</SnackbarProvider>
		</MuiThemeProvider>
	);
};




export default App;
